<template>
  <div class="post-reply__container post-reply--edit">
    <div
      v-if="replyToId"
      class="post-reply"
      @click.prevent="showPost"
      ref="replyTo"
    >
      <span class="post-reply__goto">
        <i class="fa fa-reply"></i>{{ post.memberName }}
      </span>
      {{ post.noHtmlContentTrunc }}
      <a @click.prevent="close" href="#" class="post-reply__close">&times;</a>
      <input
        type="hidden"
        name="discussion_post[parent_id]"
        :value="replyToId"
      />
    </div>
    <reply-preview :postId="post.id"></reply-preview>
  </div>
</template>
<script>
import ReplyPreview from "./ReplyPreview";
import discussionService from '../../../services/discussion_service'

export default {
  props: ["replyToId"],
  components: {
    ReplyPreview
  },

  data() {
    return {
      post: {
        noHtmlContentTrunc: ""
      },
      tooltip: null
    };
  },

  computed: {
    targetId() {
      return "#" + discussionService.getDOMId(this.post.id);
    }
  },

  methods: {
    setPost(id) {
      let post = discussionService.getData(id),
        truncatedLength = 140;
      post.noHtmlContentTrunc =
        post.noHtmlContent.substring(0, truncatedLength) +
        (post.noHtmlContent.length > truncatedLength ? "…" : "");
      this.post = post;
    },
    clearPost() {
      this.post = {
        noHtmlContentTrunc: ""
      };
    },
    close() {
      this.$eventHub.$emit("closePostReply");
    },
    showPost() {
      if (!this.post.id) return;
      discussionService.showPost(this.targetId);
    }
  },

  mounted() {
    if (this.replyToId) {
      this.setPost(this.replyToId);
    }
  },

  watch: {
    replyToId(newValue) {
      if (newValue) this.setPost(newValue);
      else this.clearPost();
    }
  }
};
</script>
